import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Login.css';

const Login: React.FC = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // 이미 로그인되어 있으면 리다이렉트
  useEffect(() => {
    const token = localStorage.getItem('token');
    const driverInfo = localStorage.getItem('driverInfo');
    
    if (token && driverInfo) {
      const driver = JSON.parse(driverInfo);
      if (driver.is_admin) {
        navigate('/admin');
      } else {
        navigate('/start-check');
      }
    }
  }, [navigate]);

  // 자동으로 현재 호스트의 IP를 사용 (모바일 지원)
  const getApiBase = () => {
    const hostname = window.location.hostname;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'http://localhost:8000';
    }
    if (window.location.protocol === 'https:') {
      return window.location.origin;
    }
    return `http://${hostname}:8000`;
  };
  
  const API_BASE = getApiBase();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${API_BASE}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.detail || '로그인 실패');
      }

      const data = await response.json();
      
      // 로컬 스토리지에 저장
      localStorage.setItem('token', data.access_token);
      localStorage.setItem('driverInfo', JSON.stringify(data.driver_info));
      
      // 로그인 후 새로고침 (캐시된 이전 버전 방지)
      // sessionStorage 초기화하여 버전 체크 다시 실행
      sessionStorage.removeItem('version_checked');
      
      // 관리자 여부에 따라 리다이렉트 후 새로고침
      if (data.driver_info.is_admin) {
        navigate('/admin');
        setTimeout(() => window.location.reload(), 100);
      } else {
        // 배송기사는 먼저 배송 시작 확인 화면으로
        navigate('/start-check');
        setTimeout(() => window.location.reload(), 100);
      }
    } catch (err: any) {
      setError(err.message || '로그인 중 오류가 발생했습니다');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>배송 차트</h1>
          <p>캐리힐 배송기사 전용</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username">아이디</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="배송기사 아이디"
              required
              autoComplete="username"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">비밀번호</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="비밀번호"
              required
              autoComplete="current-password"
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" disabled={loading} className="login-button">
            {loading ? '로그인 중...' : '로그인'}
          </button>
        </form>

        <div className="login-footer">
          <small>문의: 캐리힐 관리팀</small>
        </div>
      </div>
    </div>
  );
};

export default Login;
